import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { DashboardService } from "../../../services/dashboard.service";
import { CalaReportComponent } from "../cala-report/cala-report.component";

@Component({
  selector: "app-commissioner-report",
  templateUrl: "./commissioner-reports.component.html",
  styleUrls: [
    "../dashboard-report/dashboard-report.component.css",
    "./commissioner-reports.component.css",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissionerReportComponent extends CalaReportComponent {
  reportKind = "Commissioner";

  constructor(
    route: ActivatedRoute,
    dashboardService: DashboardService,
    cdr: ChangeDetectorRef
  ) {
    super(route, dashboardService, cdr);
  }

  get commissionerId(): string {
    return this.calaId;
  }

  get commissionerName(): string {
    return this.calaName;
  }

  get collectors(): any[] {
    return this.projects;
  }

  get collectorPages(): any[][] {
    return this.projectPages;
  }

  protected loadDashboardData(id: string) {
    return this.dashboardService.getCommissionerDashboardData(id);
  }
}
